import React from 'react'
import styles from './styles.css'
import {withRouter} from 'react-router'
import XLSX from 'xlsx'
import SendMassiveContract from './SendMassiveContract'
import withGraphQL from 'react-apollo-decorators/lib/withGraphQL'
import gql from 'graphql-tag'
import autobind from 'autobind-decorator'
import PropTypes from 'prop-types'
import Button from 'orionsoft-parts/lib/components/Button'
import withMutation from 'react-apollo-decorators/lib/withMutation'
import withMessage from 'orionsoft-parts/lib/decorators/withMessage'
import baseURL from '../../../Root/url'
import File from 'orionsoft-parts/lib/components/fields/File'
import {Form, Field} from 'simple-react-form'
import MdReplyAll from 'react-icons/lib/md/reply-all'

@withMessage
@withMutation(gql`
  mutation requestAuthenticationToken {
    token: requestAuthenticationToken {
      _id
      userId
      expiry
    }
  }
`)
@withGraphQL(gql`
  query template($templateId: ID) {
    template(templateId: $templateId) {
      _id
      name
      signersRoles {
        name
      }
      fields {
        type
      }
      feaSignersRoles {
        name
      }
      faceSignersRoles {
        name
      }
    }
  }
`)
@withRouter
export default class MassiveCreate extends React.Component {
  static propTypes = {
    showMessage: PropTypes.func,
    onChange: PropTypes.func,
    value: PropTypes.array,
    template: PropTypes.object
  }

  state = {
    header: [],
    showing: false
  }
  

  @autobind
  onChange(file) {
    var reader = new FileReader()
    reader.onload = e => {
      var file = e.target.result
      var workbook = XLSX.read(file, {
        type: 'binary',
        cellDates: true
      })
      // Here is your object
      const header = []
      for (const rol of this.props.template.signersRoles) {
        header.push(rol.name)
      }
      const data = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {
        raw: true
      })
      this.setState({data: data})
      this.setState({header: header})
    }
    reader.onerror = ex => {
      alert(ex)
    }
    reader.readAsBinaryString(file.file)
  }

  renderTable() {
    if (!this.state.data) return
    return (
      <div className={styles.container}>
        <table className={styles.tableRoles}>
          <div>
            <b>Se han cargado los elementos del excel.</b>
          </div>
          <div>Total: {this.state.data.length} fila(s)</div>
        </table>
        <br />
      </div>
    )
  }

  renderCantidadFirmas(){
    let cantidadFirmasTemplate = 0;
    let cantidadFirmasAvanzadasTemplate = 0;
    let cantidadFirmasFacialesTemplate = 0;
    if(this.props.template && this.props.template.fields){
      this.props.template.fields.forEach(field => {
        if(field.type === 'signature')
          cantidadFirmasTemplate++;
      });
    }
    if(cantidadFirmasTemplate===0)
      cantidadFirmasTemplate=1;
    
    if(this.props.template.feaSignersRoles)
      cantidadFirmasAvanzadasTemplate = this.props.template.feaSignersRoles.length

    if(this.props.template.faceSignersRoles)
      cantidadFirmasFacialesTemplate = this.props.template.faceSignersRoles.length
      

      
    if( this.state.data ){
      let firmasTotales = cantidadFirmasTemplate * this.state.data.length
      let feasTotales = cantidadFirmasAvanzadasTemplate * this.state.data.length
      let facialesTotales = cantidadFirmasFacialesTemplate * this.state.data.length

      return (
        <p>Se usará un total de {firmasTotales} firmas simples, {feasTotales} firmas avanzadas</p>
      )
    } else {
      return(
        <div>
          <p>Se usarán {cantidadFirmasTemplate} firmas simples, {cantidadFirmasAvanzadasTemplate} firmas avanzadas por cada registro</p>
        </div>
      )
    }
  }

  //  y {facialesTotales} firmas faciales
  // y {cantidadFirmasFacialesTemplate} firmas faciales

  @autobind
  async download() {
    this.setState({loading: true})
    try {
      const {token} = await this.props.requestAuthenticationToken()
      window.location.href = `${baseURL}/templates/xlsx/${this.props.template._id}/${token._id}`
    } catch (error) {
      console.log('Error:', error)
      this.props.showMessage(error.message, {level: 'error'})
    }
    this.setState({loading: false})
  }

  renderDownload() {
    return (
      <div className={styles.download}>
        <div className={styles.title}>Complete el Excel con la siguiente estructura:</div>
        <Button primary onClick={this.download} loading={this.state.loading || false}>
          Descargar modelo
        </Button>
      </div>
    )
  }

 

  render() {
    return (
      <div className={styles.container}>
        <div className="section">
          <div className="header">
            <div className="row">
              <div className={styles.Icon}>
                <MdReplyAll size={30} />
              </div>
              <div className={styles.Title}>
                <h3>Envío masivo:</h3>
              </div>
              <div className={styles.Name}>
                <h3>{this.props.template.name}</h3>
              </div>
            </div>
          </div>
          <div className="content">
            {this.renderDownload()}
            <p>Suba el archivo con los campos rellenados:</p>
            <Form state={this.state}>
              <Field fieldName="file" type={File} upload={this.onChange} />
            </Form>
            {this.renderCantidadFirmas()}
            <br />
            {this.renderTable()}
            <SendMassiveContract data={this.state.data} templateId={this.props.template._id} />
          </div>
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/App/Pages/Templates/MassiveCreate/index.js